var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit } from '@angular/core';
import { ApartmentTypesBaseComponent } from './../common-theme/index';
var HousesComponent = /** @class */ (function (_super) {
    __extends(HousesComponent, _super);
    function HousesComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HousesComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        this.pageType = this.route.snapshot.data.page_type;
        switch (this.pageType) {
            case 'apartamente-noi-rahova-salaj-sector5-bucuresti':
                this.setTitle('Apartamente noi sector 5 de la dezvoltator');
                this.setMetaDescription("\n          Apartamente si garsoniere noi de vanzare in sectorul 5.\n          Vezi promotiile de pret pentru garsoniere si apartamente noi in sectorul 5.\n        ");
                break;
            case 'cartierul-nou-salaj':
                this.setTitle('Cartierul Nou Salaj - Apartamente 2, 3 camere, Garsoniere');
                this.setMetaDescription("\n          Cartierul Nou Salaj - poti alege apartamente de 2 camere, de 3 camere si\n          garsoniere de vanzare in cadrul complexului rezidential Dream Residence.\n        ");
                break;
            case 'garsoniere-de-vanzare-rahova-sector-5':
                this.setTitle('Garsoniere de vanzare - Dream Residence, sector 5, Rahova');
                this.setMetaDescription("\n          Garsoniere de vanzare - Dream Residence, Rahova (sector 5, zona Sebastian, Pucheni).\n          Dream Residence e mai mult decat un cartier, e o comunitate!\n        ");
                break;
            case 'apartamente-2-camere-de-vanzare-rahova-sector-5':
                this.setTitle('Apartamente 2 camere de vanzare: Dream Residence, sector 5, Rahova');
                this.setMetaDescription("\n          Apartamente 2 camere de vanzare - Dream Residence, Rahova (sector 5, zona Sebastian, Pucheni).\n          Dream Residence e mai mult decat un cartier, e o comunitate!\n        ");
                break;
            case 'apartamente-3-camere-de-vanzare-rahova-sector-5':
                this.setTitle('Apartamente 3 camere de vanzare: Dream Residence, sector 5, Rahova');
                this.setMetaDescription("\n          Apartamente 3 camere de vanzare - Dream Residence, Rahova (sector 5, zona Sebastian, Pucheni).\n          Dream Residence e mai mult decat un cartier, e o comunitate!\n        ");
                break;
            default:
                this.setTitle('Apartamente 2, 3 camere, garsoniere de vanzare in sector 5');
                this.setMetaDescription("\n          Vezi apartamente de 2 camere, de 3 camere si garsoniere de vanzare in cadrul complexului rezidential Dream Residence.\n          Toate detaliile pe site.\n        ");
                break;
        }
    };
    return HousesComponent;
}(ApartmentTypesBaseComponent));
export { HousesComponent };



// WEBPACK FOOTER //
// ./src/app/houses/houses.component.ts.pre-build-optimizer.js